import { render, staticRenderFns } from "./project-documents-move-files.vue?vue&type=template&id=0da5260e&scoped=true&"
import script from "./project-documents-move-files.vue?vue&type=script&lang=js&"
export * from "./project-documents-move-files.vue?vue&type=script&lang=js&"
import style0 from "./project-documents-move-files.vue?vue&type=style&index=0&id=0da5260e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5260e",
  null
  
)

export default component.exports